/** Per-request client JWT — avoids collision with agent dashboard token on shared axios defaults. */

export function clientTokenKey(agentSlug) {
  return `a4a_client_token_${agentSlug}`;
}

export function clientAuthConfig(agentSlug) {
  if (!agentSlug) return {};
  const token = localStorage.getItem(clientTokenKey(agentSlug));
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
}
